export { addGlobalEventProcessor, addBreadcrumb, captureException, captureEvent, captureMessage, configureScope, getHubFromCarrier, getCurrentHub, Hub, Scope, setContext, setExtra, setExtras, setTag, setTags, setUser, startTransaction, withScope, } from '@sentry/browser';
export { init } from './sdk';
export { vueRouterInstrumentation } from './vuerouter';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@sentry/vue/esm/index.js
// module id = 2712
// module chunks = 29 43 45